"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const User = __importStar(require("../../../../user"));
const openapi_1 = require("../../../openapi");
const Dealer = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Dealer.Profile.Spec';
const Role = User.GlobalUserRole.enums;
const ProfileResponse = openapi_1.Response.Success(Dealer.Profile).annotations({
    description: 'Dealer profile of the current user',
});
const getProfile = platform_1.HttpApiEndpoint.get('getProfile') `/profile`
    .addSuccess(ProfileResponse)
    .annotate(platform_1.OpenApi.Title, 'Get Dealer Profile')
    .annotate(platform_1.OpenApi.Description, 'Returns the dealer locations linked to the current user through dealerIds, ordered by id. A user without dealerIds, or with a dealerIds value that is not an array, gets an empty list and a 200, not an error. Ids that match no stored location are skipped.')
    .pipe(openapi_1.Security.v1Roles(Role.Dealer, Role.DealerTechnician), openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.dealer.profile')
    .add(getProfile)
    .prefix('/dealer')
    .annotate(platform_1.OpenApi.Title, 'Dealer Profile')
    .annotate(platform_1.OpenApi.Description, 'Dealer profile of the current user');
//# sourceMappingURL=spec.js.map